import React from "react";
import styles from "./ViewBlock.module.scss";
import ViewBlockForm from "forms/ViewBlockForm/ViewBlockForm";
import Chevron from "assets/Chevron";
import { IBlock } from "database";

type ViewBlockProps = {
	close: () => void;
	selectedBlock: IBlock;
};

const ViewBlock: React.FC<ViewBlockProps> = ({ close, selectedBlock }) => {
	return (
		<div className={styles.ViewBlock}>
			<div className={styles.MainView}>
				<div className={styles.Header}>
					<div className={styles.Chevron} onClick={() => close()}>
						<Chevron />
					</div>
					<h2>{selectedBlock.name}</h2>
					<div></div>
				</div>
			</div>
			<div className={styles.idContainer}>
				<p className={styles.SiteIdHeader}>SITE ID</p>
				<p className={styles.SiteId}>
					{selectedBlock.siteId ? selectedBlock.siteId : "Not available"}
				</p>
				<p className={styles.SiteIdHeader}>BLOCK ID</p>
				<p className={styles.RecordId}>{selectedBlock.blockId}</p>
			</div>
			<ViewBlockForm defaultDetails={selectedBlock} />
		</div>
	);
};

export default ViewBlock;
